var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "nav-bar-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { lg: 6, md: 6, sm: 6, xl: 6, xs: 4 } }, [
            _c(
              "div",
              { staticClass: "left-panel" },
              [
                _c("fold"),
                _vm.layout === "comprehensive"
                  ? _c(
                      "el-tabs",
                      {
                        attrs: { "tab-position": "top" },
                        on: { "tab-click": _vm.handleTabClick },
                        model: {
                          value: _vm.firstMenu,
                          callback: function($$v) {
                            _vm.firstMenu = $$v
                          },
                          expression: "firstMenu"
                        }
                      },
                      _vm._l(_vm.handleRoutes, function(item) {
                        return _c(
                          "el-tab-pane",
                          { key: item.path, attrs: { name: item.path } },
                          [
                            _c(
                              "div",
                              { attrs: { slot: "label" }, slot: "label" },
                              [
                                item.meta.remixIcon
                                  ? _c("vab-remix-icon", {
                                      staticClass: "vab-remix-icon",
                                      attrs: { icon: item.meta.remixIcon }
                                    })
                                  : _vm._e(),
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.translateTitle(item.meta.title)
                                    ) +
                                    " "
                                )
                              ],
                              1
                            )
                          ]
                        )
                      }),
                      1
                    )
                  : _c("breadcrumb", { staticClass: "hidden-xs-only" })
              ],
              1
            )
          ]),
          _c("el-col", { attrs: { lg: 18, md: 18, sm: 18, xl: 18, xs: 4 } }, [
            _c(
              "div",
              { staticClass: "right-panel" },
              [
                _c("span", { staticStyle: { "font-weight": "bold" } }, [
                  _vm._v("项目类别：")
                ]),
                _c(
                  "el-select",
                  {
                    staticStyle: { width: "140px" },
                    attrs: { rows: 2, placeholder: "请选择项目类别" },
                    on: { change: _vm.typeChangeEvent },
                    model: {
                      value: _vm.selectType,
                      callback: function($$v) {
                        _vm.selectType = $$v
                      },
                      expression: "selectType"
                    }
                  },
                  _vm._l(_vm.typeList, function(item) {
                    return _c("el-option", {
                      key: item.value,
                      attrs: { label: item.label, value: item.value }
                    })
                  }),
                  1
                ),
                _c(
                  "span",
                  {
                    staticStyle: {
                      "font-weight": "bold",
                      "margin-left": "20px"
                    }
                  },
                  [_vm._v("选择项目:【" + _vm._s(_vm.prjInfo.prjTitle) + "】")]
                ),
                _c("el-button", {
                  attrs: {
                    size: "mini",
                    type: "primary",
                    plain: "",
                    icon: "el-icon-search",
                    circle: ""
                  },
                  on: { click: _vm.prjClick }
                }),
                _c("full-screen"),
                _c("avatar")
              ],
              1
            )
          ])
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          attrs: {
            title: "项目选择",
            visible: _vm.isPrjtable,
            direction: "rtl",
            size: "400px",
            modal: true,
            "wrapper-closable": true,
            "modal-append-to-body": false
          },
          on: {
            "update:visible": function($event) {
              _vm.isPrjtable = $event
            },
            closed: _vm.drawerClosed
          }
        },
        [
          _c("el-input", {
            staticClass: "topText",
            attrs: { placeholder: "输入关键字进行过滤" },
            model: {
              value: _vm.filterText,
              callback: function($$v) {
                _vm.filterText = $$v
              },
              expression: "filterText"
            }
          }),
          _c("el-tree", {
            ref: "tree",
            staticClass: "filter-tree",
            attrs: {
              data: _vm.projectOptions,
              "node-key": "id",
              props: _vm.defaultProps,
              "default-expand-all": "",
              "filter-node-method": _vm.filterNode,
              "current-node-key": _vm.prjInfo.prjId.toLowerCase(),
              "highlight-current": true
            },
            on: {
              "node-click": _vm.checkSingleClick,
              "check-change": _vm.chgPrjClick
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }